import { render } from "./Signup.vue?vue&type=template&id=3145b4a8"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=3145b4a8&lang=scss"

import exportComponent from "/Users/andersnielsen/Sites/demo-leverandoroverblik/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__